import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";

import { ORIGIN_INTEGRATION_INSTALL_URL } from "./gql";

const useOriginIntegrationInstallURL = () => {
  const { onError } = useTypedContext(FlashContext);

  const [originIntegrationInstallURL, { loading }] = useMutation(ORIGIN_INTEGRATION_INSTALL_URL);

  const requestInstallURL = useCallback(
    (spaceID?: string) => {
      originIntegrationInstallURL({ variables: { spaceID: spaceID ?? null } })
        .then(({ data }) => {
          if (data?.originIntegrationInstallURL) {
            window.location.href = data.originIntegrationInstallURL;
          }
        })
        .catch(onError);
    },
    [originIntegrationInstallURL, onError]
  );

  return { requestInstallURL, loading };
};

export default useOriginIntegrationInstallURL;
